import { createSelector } from 'reselect';
import {
	BadgeState,
	BadgeStudio,
	BadgeStudioSpaceObjects,
	C_ObjectType,
	C_PictureTypeCustom,
	GraphicActionType,
	GraphicDirectoryInfo,
	SaveBadgeStudioDTO,
} from '../../model/GraphicModel';
import { RootReducer } from '../rootReducer';

const badgeSelector = (state: RootReducer) => state.badgeReducer;

export const badgeInfoSelector = createSelector(badgeSelector, (badgeState: BadgeState) => badgeState.badgeInfo);

export const spaceObjectsSelector = createSelector(badgeSelector, (badgeState: BadgeState) => badgeState.spaceObjects);

export const actionTypeSelector = createSelector(badgeSelector, (badgeState: BadgeState): GraphicActionType => badgeState.graphicActionType);

export const badgeStudioSelector = createSelector(
	[badgeInfoSelector, spaceObjectsSelector],
	(BadgeInfo: BadgeStudio, SpaceObjects: BadgeStudioSpaceObjects): SaveBadgeStudioDTO => ({
		BadgeInfo,
		SpaceObjects,
	})
);

export const selectGraphicObject = (objType: C_PictureTypeCustom | C_ObjectType, id: number) =>
	createSelector([spaceObjectsSelector], (spaceObjects: BadgeStudioSpaceObjects) => {
		switch (objType) {
			case C_PictureTypeCustom.MDOT_DBBARCODE:
				return spaceObjects?.BarCodes?.find(bc => bc.Id === id);
			case C_PictureTypeCustom.MDOT_TEXT:
			case C_PictureTypeCustom.MDOT_DBTEXT:
				return spaceObjects?.Texts?.find(t => t.Id === id);
			case C_PictureTypeCustom.MDOT_DBMAGSTRIPE:
				return spaceObjects?.BadgeMagstripes?.find(ms => ms.Id === id);
			case C_PictureTypeCustom.MDOT_IMAGE:
			case C_ObjectType.OT_IMAGE:
			case C_ObjectType.OT_BITMAP:
				return spaceObjects?.Images?.find(i => i.Id === id);
			case C_PictureTypeCustom.MDOT_VIO:
				return spaceObjects?.ShapeObjects?.find(so => so.Id === id);
		}
	});

export const viewModeSelector = createSelector(badgeSelector, (badgeState: BadgeState) => badgeState.viewMode);

export const graphicActionTypeSelector = createSelector(badgeSelector, (badgeState: BadgeState) => badgeState.graphicActionType);

export const fontFamiliesSelector = createSelector(badgeSelector, (badgeState: BadgeState) => badgeState.fontFamilies);

export const udfsSelector = createSelector(badgeSelector, (badgeState: BadgeState) => badgeState.udfs);

export const udfs256Selector = createSelector(badgeSelector, (badgeState: BadgeState) => badgeState.udfs256);

export const dropDataNodesSelector = createSelector(badgeSelector, (badgeState: BadgeState) => badgeState.dropDataNodes);

export const currentRedlineConfigValuesSelector = createSelector(badgeSelector, (badgeState: BadgeState) => badgeState.currentRedlineConfigValues);

export const drawingMenuOptsDisabledSelector = createSelector(badgeSelector, (badgeState: BadgeState) => badgeState.drawingMenuOptsDisabled);

export const graphicDataSelector = createSelector(badgeSelector, (badgeState: BadgeState): Partial<GraphicDirectoryInfo> => badgeState.graphicInfo);

export const badgeHasChangedSelector = createSelector(badgeSelector, (badgeState: BadgeState) => badgeState.hasChanged);
